import { ColumnHeaderType } from "./Types";

export const findValue = (
    headerItem: ColumnHeaderType,
    item: any,
    masterData?: any
  ) => {
    if (headerItem.valueGetter) {
      return headerItem.valueGetter(item, headerItem.field, masterData) ?? 'N/A';
    } else if (headerItem.value) {
      return headerItem.value ?? 'N/A';
    } else {
      return item[headerItem.field] ?? 'N/A';
    }
  };